import {registerAPIService} from './APIServicesRegistry';
import APIServiceBase from './APIServiceBase';
import axios from 'axios'

export default class ProjectAPIService extends APIServiceBase {
    constructor() {
        super('Project')
    }

    create(data) {
        return this.post('create', data)
    }

    edit(data) {
        return this.post('edit', data)
    }

    getHistoricalData(id) {
        return this.get(`GetHistoricalData?id=${id}`);
    }

    getDocumentationModalContent(id) {
        return this.get(`GetDocumentationModalContent?projectId=${id}`)
    }

    generateXmlSignLabelData(data) {
        return this.post('GenerateXmlSignLabelData', data, 'blob')
    }

    generateDocumentation(data) {
        return this.post('GenerateDocument', data, 'blob')
    }

    generateXlsSpecification(data) {
        return this.post('GenerateXlsSpecification', data, 'blob')
    }

    getConfigurationCollection(data) {
        return this.post('GetConfigurationCollection', data)
    }

    getConfigurationsList(projectId) {
        return this.post(`GetConfigurationsList?id=${projectId}`)
    }

    getFileCollection(data) {
        return this.post('GetFileCollection', data)
    }

    hide(id) {
        return this.post(`Hide?id=${id}`)
    }

    delete(id) {
        return this.get(`Delete?id=${id}`)
    }

    deleteBatch(data) {
        return this.post('DeleteBatch', data)
    }

    copy(id) {
        return this.get(`Copy?id=${id}`)
    }

    copyAndEdit(id) {
        return this.get(`CopyAndEdit?id=${id}`);
    }

    reviseAndEdit(id) {
        return this.get(`ReviseAndEdit?id=${id}`);
    }

    transform(data) {
        return this.post('TransformProject', data);
    }

    sendQuote(data) {
        return this.post('SendQuote', data);
    }

    createConfiguration(data) {
        return this.post('CreateConfiguration', data)
    }

    copyConfiguration(data) {
        return this.post('CopyConfiguration', data)
    }

    copyConfigurationAsOptional(data) {
        return this.post('CopyConfigurationAsOptional', data)
    }

    editConfiguration(data) {
        return this.post('EditConfiguration', data)
    }

    calculateConfigurationsPrices(data) {
        return this.post('CalculateConfigurationsPrices', data)
    }

    getSendQuoteData(data) {
        return this.get(`GetSendQuoteData?projectId=${data}`)
    }

    setProductSerialNumber(data) {
        return this.post('SetProductSerialNumber', data)
    }
}

registerAPIService(ProjectAPIService)